import Heading from "atoms/typography/heading";
import PublicationRecord from "models/view-models/publication-record";
import React from "react";
import usePublicationCover from "utilities/hooks/domain/publications/use-publication-cover";

interface PublicationMetaCardProps {
    publication: PublicationRecord;
}

const CSS_CLASS_NAME = "c-publication-meta-card";

const PublicationMetaCard = ({ publication }: PublicationMetaCardProps) => {
    const { coverImageSrc } = usePublicationCover(publication);
    return (
        <section className={CSS_CLASS_NAME}>
            <div className={`${CSS_CLASS_NAME}__meta`}>
                <Heading cssClassName={`${CSS_CLASS_NAME}__edition`}>
                    {publication.edition}
                </Heading>
                <Heading cssClassName={`${CSS_CLASS_NAME}__code`}>
                    {publication.getDisplayCode()}
                </Heading>
                <Heading cssClassName={`${CSS_CLASS_NAME}__title`}>
                    {publication.title}
                </Heading>
            </div>
            <div className={`${CSS_CLASS_NAME}__imageWrapper`}>
                {!!coverImageSrc ? (
                    <img
                        className={`${CSS_CLASS_NAME}__image`}
                        src={coverImageSrc}
                        alt={`${publication.getDisplayCodeEditionAndTitle()} cover`}
                        loading="lazy"
                    />
                ) : (
                    <div className={`${CSS_CLASS_NAME}__image -no-cover`} />
                )}
            </div>
        </section>
    );
};

export default PublicationMetaCard;
